<template>
  <el-select
      v-model="normalizedValue"
      :placeholder="placeholder"
      :multiple="multiple"
      :clearable="clearable"
      @change="handleChange"
  >
    <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'VisionSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: [
        { label: '4.0', value: '4.0' },
        { label: '4.1', value: '4.1' },
        { label: '4.2', value: '4.2' },
        { label: '4.3', value: '4.3' },
        { label: '4.4', value: '4.4' },
        { label: '4.5', value: '4.5' },
        { label: '4.6', value: '4.6' },
        { label: '4.7', value: '4.7' },
        { label: '4.8', value: '4.8' },
        { label: '4.9', value: '4.9' },
        { label: '5.0', value: '5.0' },
        { label: '5.1', value: '5.1' },
        { label: '5.2', value: '5.2' },
        { label: '5.3', value: '5.3' }
      ]
    },
    placeholder: {
      type: String,
      default: '请选择视力'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      normalizedValue: this.normalizeValue(this.value)
    };
  },
  watch: {
    value(newVal) {
      this.normalizedValue = this.normalizeValue(newVal);
    }
  },
  methods: {
    normalizeValue(val) {
      if (!val) return '';
      // 将数字或字符串转换为字符串，并规范化小数位为1位（去除多余的0）
      let numStr = String(val).replace(/\.0+$/, '.0').replace(/^0+/, '0');
      // 如果是整数如5，添加.0
      if (!/\./.test(numStr)) {
        numStr += '.0';
      }
      // 限制小数位为1位
      const parts = numStr.split('.');
      if (parts[1] && parts[1].length > 1) {
        parts[1] = parts[1].substring(0, 1);
      }
      return parts.join('.');
    },
    handleChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};

// 生成默认视力选项（0.1 到 5.0，步长0.1）
function generateDefaultOptions() {
  const options = [];
  for (let i = 4.0; i <= 5.3; i += 0.1) {
    const val = i.toFixed(1);
    options.push({
      value: val,
      label: val
    });
  }
  return options;
}
</script>

<style scoped>
/* 可根据需要添加样式 */
</style>
